import { render, staticRenderFns } from "./FilterItems.vue?vue&type=template&id=33e8b282&scoped=true"
import script from "./FilterItems.vue?vue&type=script&lang=js"
export * from "./FilterItems.vue?vue&type=script&lang=js"
function injectStyles (context) {
  
  var style0 = require("./FilterItems.vue?vue&type=style&index=0&id=33e8b282&prod&lang=scss&scoped=true")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "33e8b282",
  null
  ,true
)

export default component.exports